import React from 'react';

import {
  Link,
} from 'react-router-dom';

import Logo
  from '../assets/img/logo/Logo_final_transparent.png';

import TwitterLogo
  from '../assets/img/icons/socials/twitter.svg';

import LinkedInLogo
  from '../assets/img/icons/socials/Linkedin icon.svg';

import {
  useLanguage,
} from '../context/LanguageContext';

import './Header.css';


const Header = () => {
  const {
    language,
    setLanguage,
  } = useLanguage();

  const isFrench =
    language === 'fr';

  return (
    <header className="ace-public-header">

      <div className="ace-header-top">
        <div className="ace-header-top-inner">

          <div className="ace-header-socials">
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <img
                src={LinkedInLogo}
                alt=""
              />
            </a>

            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <img
                src={TwitterLogo}
                alt=""
              />
            </a>
          </div>


          <div
            className="ace-language-switch"
            aria-label={
              isFrench
                ? 'Choisir la langue'
                : 'Choose language'
            }
          >
            <button
              type="button"
              className={
                language === 'en'
                  ? 'active'
                  : ''
              }
              onClick={() =>
                setLanguage('en')
              }
            >
              EN
            </button>

            <span aria-hidden="true">
              /
            </span>

            <button
              type="button"
              className={
                language === 'fr'
                  ? 'active'
                  : ''
              }
              onClick={() =>
                setLanguage('fr')
              }
            >
              FR
            </button>
          </div>

        </div>
      </div>


      <div className="ace-header-main">
        <div className="ace-header-main-inner">

          <Link
            to="/"
            className="ace-header-logo-link"
            aria-label={
              isFrench
                ? 'Accueil ACE'
                : 'ACE home'
            }
          >
            <img
              src={Logo}
              alt="Actions, Culture of Excellence"
              className="ace-header-logo"
            />
          </Link>


          <nav
            className="ace-public-nav"
            aria-label={
              isFrench
                ? 'Navigation principale'
                : 'Main navigation'
            }
          >
            <Link to="/">
              {isFrench
                ? 'Accueil'
                : 'Home'}
            </Link>

            <Link to="/homes/main">
              {isFrench
                ? 'À propos'
                : 'About'}
            </Link>

            <Link to="/posts">
              MSMEs World
            </Link>

            <Link to="/homes/announces">
              {isFrench
                ? 'Opportunités'
                : 'Opportunities'}
            </Link>

            <Link to="/users/sponsors">
              {isFrench
                ? 'Partenaires'
                : 'Partners'}
            </Link>

            <Link
              to="/results-framework"
            >
              {isFrench
                ? 'Résultats'
                : 'Results'}
            </Link>
          </nav>

        </div>
      </div>

    </header>
  );
};


export default Header;
